import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { Calendar, ClipboardList } from 'lucide-react';

export default function SchedulesPageWrapper() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    {
      name: 'Scheduling Canvas',
      path: '/schedules/canvas',
      icon: Calendar,
    },
    {
      name: 'Time Off & Swap Requests',
      path: '/schedules/requests',
      icon: ClipboardList,
    },
  ];

  const activeTab = tabs.find((tab) => location.pathname.startsWith(tab.path)) || tabs[0];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Schedules</h1>
        <p className="text-gray-600 mt-2">Manage scheduling and time-off requests</p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="flex space-x-8">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab.path === tab.path;

            return (
              <button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  isActive
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center space-x-2">
                  <Icon className="h-4 w-4" />
                  <span>{tab.name}</span>
                </div>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Content */}
      <Outlet />
    </div>
  );
}
